import { memo, useCallback, useState } from 'react';
import { defaultDownloadUrl } from '@@/config';
import { isIOS } from '@@/utils';
import { env } from '@diezhi/momo';
import { useMultiSound, useHideDownload } from '@@/hooks';
import { multiSoundConfig } from '@/src/config';
import { navListData } from '../NavBar/config';

import styles from './style.module.scss';

const NavBarM = ({
  setSelectedIndex,
  external, // 非home页下的导航栏
  downloadData,
  forceHideDownload,
}) => {
  const [soundsAction, soundsStatus] = useMultiSound(multiSoundConfig);
  const [navActive, setNavActive] = useState(false);
  const hideDownload = useHideDownload();

  let isShowDownlaod = true;

  if (hideDownload) {
    isShowDownlaod = false;
  }

  if (forceHideDownload) {
    isShowDownlaod = false;
  }

  const onSwitchPlay = () => {
    if (soundsStatus['bg']) {
      soundsAction.pause('bg');
    } else {
      soundsAction.play('bg');
    }
  };

  const onClickNav = useCallback(
    (e) => {
      e.stopPropagation();
      const index = Number(e.currentTarget.dataset.index);
      const item = navListData[index];
      if (item.url) {
        window.open(item.url);
        return;
      }
      if (external) {
        let link = `/home${hideDownload ? '?hideDownload=true' : ''}#${index === 0 ? 0 : index + 1}`;
        if (window.location.pathname.startsWith('/m/')) {
          link = `/m/${link}`;
        }
        window.location.assign(link);
        return;
      }
      setNavActive(false);
      setSelectedIndex(index === 0 ? 0 : index + 1);
    },
    [setSelectedIndex, external],
  );

  const onDownload = () => {
    const url =
      env.isIpad() || env.isIOS()
        ? downloadData.dIos || defaultDownloadUrl.dIos
        : downloadData.dAndroid || defaultDownloadUrl.dAndroid;
    window.open(url);
  };

  return (
    <div className={styles.navContainer}>
      <div
        className={styles.logo}
        onClick={() => {
          if (hideDownload) {
            console.log('下载页不显示logo');
            return;
          }
          if (external) {
            window.location.assign('/m/home');
            return;
          }
          setSelectedIndex(0);
        }}
      />
      <div className={styles.rightWrap}>
        {isShowDownlaod && <div className={styles.downloadBtn} onClick={onDownload} />}
        <div className={`${styles.audioBtn} ${soundsStatus?.bg ? styles.active : ''}`} onClick={onSwitchPlay} />
        {isShowDownlaod && (
          <div
            className={styles.navBtn}
            onClick={() => {
              setNavActive(!navActive);
            }}
          />
        )}
      </div>
      <div className={`${styles.navBody} ${navActive ? styles.active : ''}`}>
        <div
          className={styles.closeBtn}
          onClick={() => {
            setNavActive(false);
          }}
        />
        {navListData.map((item, index) => {
          return (
            <div key={index} data-index={index} className={styles.navItem} onClick={onClickNav}>
              <img src={item.img.default.src} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

NavBarM.defaultProps = {
  setSelectedIndex: 0,
  external: false,
  downloadData: {
    dIos: defaultDownloadUrl.dIos,
    dAndroid: defaultDownloadUrl.dAndroid,
  },
  forceHideDownload: false,
};

export default memo(NavBarM);
